<template>
  <div class="privacy-title">
    <h1 class="mb-4">Privacy Policy</h1>
    <p class="lead mb-4">
      Informativa sulla Privacy di AppScontrini
    </p>
    <p class="subtitle mb-4">
      La tua privacy è importante per noi. Questa informativa descrive come raccogliamo, 
      utilizziamo e proteggiamo i tuoi dati personali quando utilizzi il nostro sito web 
      e l'applicazione mobile "App degli Scontrini".
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyTitle'
}
</script>

<style scoped>
.privacy-title h1 {
  color: white;
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.privacy-title .lead {
  font-size: 1.5rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 1.5rem;
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

.privacy-title .subtitle {
  font-size: 1.1rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  max-width: 800px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .privacy-title h1 {
    font-size: 2.5rem;
  }

  .privacy-title .lead {
    font-size: 1.3rem;
  }

  .privacy-title .subtitle {
    font-size: 1rem;
    padding: 0 1rem;
  }
}

@media (max-width: 576px) {
  .privacy-title h1 {
    font-size: 2rem;
  }

  .privacy-title .lead {
    font-size: 1.1rem;
  }
}
</style>

